<template>
  <el-select
    v-model="controller.value"
    class="table-controller"
    popper-class="table-controller__list"
    @change="$emit('onControllerChange', controller)"
  >
    <template v-slot:prefix>
      <span
        class="table-controller__label table-cell table-cell--header font-table__header"
      >
        {{ columnLabel }}
      </span>
    </template>

    <el-option
      v-for="item in controller.list"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
      <span class="font-table__content">{{ item.label }}</span
      ><span>{{ item.count }}</span>
      <i class="el-icon-check"></i>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'TableCrontroller',

  props: {
    columnLabel: {
      type: String,
      default: ''
    },
    controller: {
      type: Object,
      required: true
    },
    cloumnCount: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss">
.table-controller {
  width: 100%;
  height: 40px;
  &__icon {
    margin-left: 5px;
    border: 9px solid transparent;
    border-top-color: $color-primary;
    border-radius: 3px;
    transform: translateY(25%);
    cursor: pointer;
  }
  .el-input {
    display: flex;
    align-items: center;
    justify-content: center;
    &__inner {
      padding: 0;
      width: 0;
      border: 0;
      opacity: 0;
    }
    &__prefix {
      position: unset;
    }
    &__suffix {
      position: unset;
    }
    &__icon {
      font-size: 20px !important;
      color: $color-primary !important;
      &::before {
        content: '\e790';
      }
    }
  }
}
.table-controller__list {
  .popper__arrow {
    display: none;
  }
  &.el-select-dropdown {
    margin-top: 2px;
    border-color: $color-border-light;
  }
  .el-select-dropdown {
    &__list {
      padding: 0;
    }
    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      height: auto;
      line-height: normal;
      border-bottom: 1px solid $color-border-light;
      &.selected {
        .el-icon-check {
          opacity: 1;
        }
      }
    }
  }
  .el-icon-check {
    opacity: 0;
    font-size: 20px;
  }
}
</style>
